import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Manager.vue'
import Login from '../views/Login.vue'
import ConsiderRequestFromEmail from '../views/modules/ConsiderRequestFromEmail.vue'
import { safeParseLocalStorage } from '@/utils/storageUtils'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/requests',
    name: 'ConsiderRequestFromEmail',
    component: ConsiderRequestFromEmail
  },
  {
    path: '/manager',
    component: Main,
    children: [
      {
        path: '/',
        name: 'Reporting',
        component: () => import('../views/modules/Report.vue')
      },
      {
        path: 'reporting',
        name: 'Reporting New',
        component: () => import('../views/modules/Reporting.vue')
      },
      {
        path: 'general-reports/:id?',
        name: 'GeneralReports',
        component: () => import('../views/modules/GeneralReports.vue')
      },
      {
        path: 'reports',
        name: 'ManagerReports',
        component: () => import('../views/modules/ManagerReports.vue')
      },
      {
        path: 'clients',
        name: 'Clients',
        component: () => import('../views/modules/Clients.vue')
      },
      {
        path: 'projects',
        name: 'Projects',
        component: () => import('../views/modules/Projects.vue')
      },
      {
        path: 'edit-tasks',
        name: 'EditTasks',
        component: () => import('../views/modules/EditTasks.vue')
      },
      {
        path: 'employee/:employeeId?',
        name: 'Employee',
        component: () => import('../views/modules/Employee.vue')
      },
      {
        path: 'employee-skills',
        name: 'EmployeeSkills',
        component: () => import('../views/modules/EmployeeSkills.vue')
      },
      {
        path: 'summary',
        name: 'Summary',
        component: () => import('../views/modules/Summary.vue')
      },
      {
        path: 'absence-transfer',
        name: 'AbsenceTransfer',
        component: () => import('../views/modules/Absence.vue')
      },
      {
        path: 'invoices',
        name: 'Invoices',
        component: () => import('../views/modules/Invoices.vue')
      },
      {
        path: 'admin-assets',
        name: 'AdminAssets',
        component: () => import('../views/modules/AdminAssets.vue')
      },
      {
        path: 'admin-human-resources',
        name: 'AdminHumanResources',
        component: () => import('../views/modules/AdminHumanResources.vue')
      },
      {
        path: 'admin-project-management',
        name: 'AdminProjectManagement',
        component: () => import('../views/modules/AdminProjectManagement.vue')
      },
      {
        path: 'admin-settings',
        name: 'AdminSystemSettings',
        component: () => import('../views/modules/AdminSystemSettings.vue')
      },
      {
        path: 'admin-emails-management',
        name: 'AdminEmailsMailingManagement',
        component: () => import('../views/modules/AdminEmailsMailing.vue')
      },
      {
        path: 'admin-documents-management',
        name: 'AdminDocumentsManagement',
        component: () => import('../views/modules/AdminDocuments.vue')
      },
      {
        path: 'anniversary',
        name: 'Anniversary',
        component: () => import('../views/modules/Anniversary.vue')
      },
      {
        path: 'pr-matrix-summary',
        name: 'PRMatrixSummary',
        component: () => import('../views/modules/PRMatrixSummary.vue')
      },
      {
        path: 'pr-matrix-charts',
        name: 'PRMatrixCharts',
        component: () => import('../views/modules/PRMatrixCharts.vue')
      },
      {
        path: 'empl-project-period',
        name: 'EmployeeProjectPeriod',
        component: () => import('../views/modules/EmployeeProjectPeriod.vue')
      },
      {
        path: 'project-kpis',
        name: 'ProjectKPIs',
        component: () => import('../views/modules/ProjectKPIs.vue')
      },
      {
        path: 'assets',
        name: 'Assets',
        component: () => import('../views/modules/Assets.vue')
      },
      {
        path: 'payroll',
        name: 'Payroll',
        component: () => import('../views/modules/Payroll.vue')
      },
      {
        path: 'payroll-documents',
        name: 'PayrollDocuments',
        component: () => import('../views/modules/PayrollDocuments.vue')
      },
      {
        path: 'requests',
        name: 'Requests',
        component: () => import('../views/modules/Requests.vue')
      },
      {
        path: 'jira-velocity',
        name: 'JiraVelocity',
        component: () => import('../views/modules/JiraVelocity.vue')
      },
      {
        path: 'admin-prm-sync',
        name: 'PrmSyncAdmin',
        component: () => import('../views/modules/PrmSync.vue')
      },
      {
        path: 'udemy-access',
        name: 'UdemyAccess',
        component: () => import('../views/modules/UdemyAccess.vue')
      }
    ]
  },
  {
    path: '*',
    redirect: { name: 'Login' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const publicRouteNames = new Set(['Login', 'ConsiderRequestFromEmail'])

function hasStoredAuthToken () {
  const data = safeParseLocalStorage('dcmweb')
  return Boolean(data && data.token)
}

router.beforeEach((to, from, next) => {
  if (publicRouteNames.has(to.name) || hasStoredAuthToken()) {
    next()
    return
  }
  next({ name: 'Login' })
})

router.afterEach((to, from) => {
  if (to.name === 'ConsiderRequestFromEmail') {
    return
  }
  const dcmwebData = safeParseLocalStorage('dcmweb')
  if (dcmwebData && dcmwebData.token) {
    if (to.name !== 'Login') localStorage.setItem('dcmweb_lpn', to.name)
  } else {
    localStorage.setItem('dcmweb_lpn', to.name)
  }
})

export default router
